import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'

Vue.use(Router)
// 解决elementUI导航栏中的vue-router在3.0版本以上重复点击菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location){
  return originalPush.call(this,location).catch(err=>err)
}

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location){
  return originalReplace.call(this,location).catch(err=>err)
}
const router = new Router({
  routes,
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js